// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TickerStatus_wrapper__irtPY","tickerStatus":"TickerStatus_tickerStatus__ZsKtz"};